export enum SiteReviewNoteEnums {
  SiteOverview = 'Site Overview',
  IdentityVerification = 'Identity Verification',
  ParcelOwnership = 'Parcel Ownership',
  SiteCheck = 'Site Check',
  SupportingDocuments = 'Supporting Documents',
  Other = 'Other',
}
